import { useState } from 'react'
import { Button } from '@/ui/components/'
import { Badge } from '@/ui/components/'
import { Sparkles } from '@/ui/icons'
import type { FeedCard as FeedCardType } from '@/shared/api'
import { UpgradeModal } from '@/modules/subscriptions'
import { FeedRow } from './FeedRow'
import { RANGER_ICON_CHIP } from './AiRecommendationCard'

interface AiUpsellCardProps {
  card: FeedCardType
}

/**
 * Shown to free users in the AI slot. Deliberately mirrors AiRecommendationCard's
 * icon chip so the row reads as "this is Ranger" before "it's locked". Opens the
 * upgrade modal in place rather than navigating away from the dashboard.
 */
export function AiUpsellCard({ card }: AiUpsellCardProps) {
  const [upgradeOpen, setUpgradeOpen] = useState(false)

  return (
    <>
      <FeedRow
        title={card.title}
        subtitle={card.body}
        icon={Sparkles}
        iconChipClassName={RANGER_ICON_CHIP}
        badge={
          <Badge variant="secondary" className="bg-adventure-100 text-adventure-700 dark:bg-adventure-900/40 dark:text-adventure-300">
            Pro
          </Badge>
        }
        action={
          <Button size="sm" onClick={() => setUpgradeOpen(true)}>
            {card.actionText || 'Upgrade'}
          </Button>
        }
      />
      <UpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} />
    </>
  )
}
